<template>
	<div>
		<TopNav activeIndex="My" />
		<div class="tabs-box">
			<el-tabs type="card">
				<el-tab-pane label="账号信息">
					<el-row>
						<el-col :span="8">
							<div class="card-con">
								<div class='card-tle'>账户id</div>
								<el-input size='small' disabled placeholder="" v-model="userinfo.id"></el-input>
								<div class='card-tle'>姓名</div>
								<el-input size='small' disabled placeholder="" v-model="userinfo.username"></el-input>
								<!-- <div class='card-tle'>邀请码</div>
								<div style="display: flex;">
									<el-input size='small' disabled placeholder="" v-model="userinfo.invite_code"></el-input>
									<el-button type="primary" class="copybtn" @click="copytxt(userinfo.invite_code)" size="small">复制</el-button>
								</div> -->
								<div class='card-tle'>密码</div>
								<el-button size="small" @click="dialogVisible = true">修改密码</el-button>
								<div class='card-tle'>绑定微信</div>
								 <!-- @click='jbwechatdialogVisible = true' -->
								<el-tag v-if="userwechat" @click="getwechatimg()" type="success" style="cursor: pointer;">已绑定微信({{userinfo.userwechat}}/{{userinfo.userwechatCount}})</el-tag>
								<el-button size="small" v-else @click="getwechatimg()">点击绑定</el-button>
								
								
								<div class="user-wechat" v-if="false">
									<div class='user-wechat-item'>
										<img class="user-wechat-img" src="../../assets/kefu.png" alt="" />
										昵称列表
										<i class="el-icon-close"></i>
									</div>
								</div>
								<div class='card-tle'>验证状态</div>
								<el-button size="small" v-if="userinfo.authstatus == 0"
									@click="showuserauth">点击验证</el-button>
								<el-tag type="success" v-else>已验证</el-tag>
							</div>
						</el-col>
					</el-row>
				</el-tab-pane>
				<!-- <el-tab-pane label="我的推荐">
					<div>
						bbb
					</div>
				</el-tab-pane> -->
			</el-tabs>
		</div>
		<!-- 解绑微信 -->
		<el-dialog title="提示" :visible.sync="jbwechatdialogVisible" width="25%">
			<span>是否要解绑微信，解绑后无法收到消息通知！</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="jbwechatdialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="qrjbwechat">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 密码修改框 -->
		<el-dialog title="修改密码" :visible.sync="dialogVisible" width="30%">
			<el-form ref="form" :model="form" :rules="rules" class="login-form" @submit.native.prevent="changepwd">
				<el-form-item prop="oldpassword" label="旧密码" required>
					<el-input v-model="form.oldpassword" :show-password='true' :clearable='true' type="password"
						placeholder="请输入旧密码"></el-input>
				</el-form-item>
				<el-form-item prop="newpassword" label="新密码" required>
					<el-input v-model="form.newpassword" :show-password='true' :clearable='true' type="password"
						placeholder="请输入新密码,6-20位数字、字母"></el-input>
				</el-form-item>
				<el-form-item prop="qdnewpassword" label="确认新密码" required>
					<el-input v-model="form.qdnewpassword" :show-password='true' :clearable='true' type="password"
						placeholder="请确认新密码,6-20位数字、字母"></el-input>
				</el-form-item>
				<el-button type="primary" native-type="submit" :loading="loading" class="login-btn">
					确定
				</el-button>
			</el-form>
		</el-dialog>

		<!-- 微信绑定弹出框 -->
		<el-dialog title="绑定微信" @close='wxbdclose' :visible.sync="wechatdialogVisible" width="30%">
			<el-alert title="使用微信扫码绑定" type="success" center :closable='false'></el-alert>
			<el-alert
				v-if="userinfo.userwechat >= userinfo.userwechatCount"
				style="margin-top: 10px;"
				center :closable='false'
			    title="您当前绑定的微信数量已达上限，继续扫码绑定将自动解绑首个绑定的微信！"
			    type="error">
			  </el-alert>
			<div style="display: flex;align-items: center;justify-content: center;">
				<el-image style="width: 80%; height: 80%;margin: 20px;" :src="wechatimg" fit="cover"></el-image>
			</div>
			<el-alert title="如已关注公众号，请先取消关注再重新扫码绑定，绑定后可搜索平台内《测试专利》并预留，用于测试是否能正常接收工单消息推送" type="warning" center
				:closable='false'>
			</el-alert>
		</el-dialog>

		<!-- 认证绑定弹出框 -->
		<el-dialog title="用户认证" :visible.sync="authdialogVisible" width="30%">
			<el-form ref="form" class="login-form" @submit.native.prevent="userauth">
				<el-form-item prop="authcon" label="认证内容">
					<el-input v-model="authcon" :clearable='true' type="textarea"
						placeholder="请输入认证内容,留下你的联系方式"></el-input>
				</el-form-item>
				<el-button type="primary" native-type="submit" :loading="loading" class="login-btn">
					确定
				</el-button>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import TopNav from '../../components/TopNav.vue'
	import userApi from '@/api/user'
	export default {
		components: {
			TopNav
		},
		data() {
			return {
				userinfo: '',
				searh_zlh_val: 'qq',
				wechatdialogVisible: false, //微信弹出框
				wechatimg: "", //微信 授权二维码
				userwechat: false, //用户是否绑定微信
				scene_str: '', //轮询检查绑定结果
				dialogVisible: false, //密码修改框
				jbwechatdialogVisible:false,//解绑微信弹出框
				form: {
					oldpassword: '',
					newpassword: '',
					qdnewpassword: ''
				},
				rules: {
					oldpassword: [{
							required: true,
							message: '请输入旧密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
					newpassword: [{
							required: true,
							message: '请输入新密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
					qdnewpassword: [{
							required: true,
							message: '请确认新密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
				},
				loading: false,
				authdialogVisible: false, //认证弹出框
				authcon: '', //认证内容
				dsq:'',//定时器

			}
		},
		created: function() {
			this.getuser();
		},
		methods: {
			getuser(){
				userApi.getProfile().then(res => {
					this.userinfo = res.data.userinfo;
					localStorage.setItem('token', res.data.userinfo.token)
					localStorage.setItem('userinfo', JSON.stringify(res.data.userinfo))
					if (this.userinfo.userwechat>0) {
						this.userwechat = true;
					}
				})
			},
			qrjbwechat(){
				userApi.unbindWechat().then(res => {
					this.userwechat = false;
					this.jbwechatdialogVisible = false;
					this.$message({
						message: '解绑成功！',
						type: 'success'
					});
				})
			},
			// 复制文本
			copytxt(txt) {
				this.$copyText(txt).then(
					(e) => {
						this.$message({
							message: '已成功复制到剪切板',
							type: 'success'
						});
					},
					(err) => {
						this.$message.error('复制失败');
					}
				);
			},
			showuserauth() {
				this.authcon = '';
				this.authdialogVisible = true;
			},
			// 用户认证
			userauth() {
				if (this.authcon == '') {
					this.$message({
						message: '请输入认证内容',
						type: 'error'
					});
					return false
				}
				userApi.userauth({
					authcon: this.authcon
				}).then(res => {
					this.$message({
						message: res.msg,
						type: 'success'
					});
					this.authdialogVisible = false;
				})
			},
			//修改密码
			changepwd() {
				userApi.changepwd(this.form).then(res => {
					this.$message({
						message: res.msg,
						type: 'success'
					});
					this.$store.state.userinfo = null;
					localStorage.removeItem('userinfo');
					this.$store.state.token = null;
					localStorage.removeItem('token');
					this.$router.push('login');
				})
			},
			wxbdclose(){
				clearInterval(this.dsq)
			},
			//获取微信二维码
			getwechatimg() {
				userApi.getWechatImg().then(res => {
					this.wechatimg = res.data.qr_code_url;
					this.scene_str = res.data.scene_str;
					this.wechatdialogVisible = true;
					this.getuserwechat();
				})
			},
			//验证是否绑定
			getuserwechat() {
				var num = 0;
				var that = this;
				this.dsq = setInterval(function() {
					num++;
					userApi.getuserwechat({
						scene_str: that.scene_str
					}).then(res => {
						if (res.data == 2) {
							// that.userwechat = true;
							that.wechatdialogVisible = false;
							that.getuser();
							clearInterval(this.dsq)
						}
					})
					if (num == 40) {
						clearInterval(this.dsq)
					}

				}, 2000)
			}
		}


	}
</script>

<style lang="less">
	.tabs-box {
		width: 96%;
		margin: 30px auto 12px auto;
		background-color: #ffffff;
		border-radius: 8px;

		.el-tabs__header {
			background-color: #f5f7fa;
			border-bottom: none !important;
		}

		.el-tabs__nav {
			border: none !important;
		}

		.is-active {
			background-color: #ffffff;
		}

		.el-tabs__item {
			border: none !important;
		}

		.card-con {
			padding: 20px 20px;

			.card-tle {
				line-height: 50px;
			}

			.copybtn {
				margin-left: 10px;
			}
			// .user-wechat{
			// 	display: flex;
			// 	align-items: center;
			// 	width: auto;
			// 	flex-wrap: wrap;
			// 	.user-wechat-item{
			// 		float: left;
			// 		padding:6px 20px;
			// 		display: flex;
			// 		align-items: center;
			// 		border-radius: 6px;
			// 		margin-top: 10px;
			// 		margin-right: 12px;
			// 		background-color: #ecf5ff;
			// 		border-color: #d9ecff;
			// 		color: #409EFF;
			// 		.user-wechat-img{
			// 			width: 40px;
			// 			height: 40px;
			// 			margin-right: 12px;
			// 		}
			// 		.el-icon-close{
			// 			cursor: pointer;
			// 			margin-left: 6px;
			// 		}
			// 	}
				
			// }
			
		}
	}
	
	// 弹出框
	.login-btn {
		width: 100%;
		margin-top: 20px;
	}
</style>